
import {map, publishReplay, refCount, catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';


import { AppHttpService } from '../../../app-http.service';
import { ModuleElementStatusbar } from './module-element-statusbar';
import { GenericCrudService } from '../generic-crud.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ModuleElementStatusbarCrudService extends AppHttpService {

  private toolbarItemsUrl: string = 'superadmin/moduleelements/:moduleElementId/statusbaritems';
  private apiUrl: string = '';

  constructor(
    private genericCrudService: GenericCrudService,
    private httpClient: HttpClient
  ) {
    super();
    this.apiUrl = this.getApiUrl();
  }

  /**
   * @param moduleElement
   * @returns {Observable<R>}
   */
  getStatusbarItems(moduleElementId: number): Observable<ModuleElementStatusbar[]> {
    if (!moduleElementId) {
      throw new Error('Element object or Element id not given.');
    }

    const url = this._createUrl(moduleElementId);

    return this.genericCrudService.get(url).pipe(
      publishReplay(1),
      refCount(),
      catchError(this.handleError));
  }

  /**
   * @param moduleElement
   * @returns {Observable<R>}
   */
  saveItems(moduleElementId: number, items: any[]): Observable<any> {
    if (!moduleElementId) {
      throw new Error('Element object or Element id not given.');
    }

    const url = this.apiUrl + '/' + this._createUrl(moduleElementId);

    return this.httpClient.post(
      url,
      JSON.stringify(items),
      { params: this.genericCrudService.getRequestOptions().getHttpParams() }
    ).pipe(
      map(this.extractEmbeddedEntities, this));
  }

  _createUrl(moduleElementId: number) {
    const re = /\:moduleElementId/gi;

    return this.toolbarItemsUrl.replace(re, String(moduleElementId));
  }
}
